export enum HostnameEnum {
  engageHub = 'tier3.dev-ehub.poc-chatter.com',
  yourBank = 'engage.yourbank.inator.cloud'
}
